export enum EndCustomerType {
    domestic = "domestic",
    Export = "Export",
   
}